import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { RequestHistoryGetPayload } from 'Interfaces/RequestsHistory';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: RequestHistoryGetPayload) =>
    $actions.requestHistory.getRequestHistory(dispatch, payload),
  );
};
